/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Standings_Help_CutoffInputs */



/**
* | output |
* | --- |
* | "During preliminaries, players only see the score needed for the top 5. Full standings show once the finals start." |
*
* @param {Tfield_Standings_Help_CutoffInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_standings_help_cutoff = /** @type {((inputs?: Tfield_Standings_Help_CutoffInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Standings_Help_CutoffInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pendant les rondes qualificatives, les joueurs ne voient que le score nécessaire pour le top 5. Le classement complet s'affiche au début de la finale.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Durante las rondas clasificatorias, los jugadores solo ven la puntuación necesaria para el top 5. La clasificación completa aparece al empezar la final.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Durante as rodadas classificatórias, os jogadores só veem a pontuação necessária para o top 5. A classificação completa aparece quando a final começa.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durante i round preliminari, i giocatori vedono solo il punteggio necessario per la top 5. La classifica completa appare all'inizio della finale.")
	return /** @type {LocalizedString} */ ("During preliminaries, players only see the score needed for the top 5. Full standings show once the finals start.")
});